import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { scrollToSection, scrollToTop } from "@/hooks/useLenis";

const LINKS = [
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Studio", href: "#studio" },
  { label: "Estimate", href: "#estimate" },
  { label: "Contact", href: "#quote" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    scrollToSection(href);
  };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#111110]/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={scrollToTop}
          className="flex items-baseline gap-2 group"
        >
          <span className="font-serif text-2xl tracking-tight text-[#F4F3F0]">
            Green Star Renos
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#C05C3F] group-hover:text-[#F4F3F0] transition-colors duration-300">
            / general trading
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="font-mono text-xs uppercase tracking-[0.2em] text-[#F4F3F0]/70 hover:text-[#C05C3F] transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-quote-btn"
            onClick={() => go("#quote")}
            className="font-mono text-xs uppercase tracking-[0.2em] bg-[#C05C3F] text-[#F4F3F0] px-5 py-2.5 hover:bg-[#F4F3F0] hover:text-[#111110] transition-colors duration-300"
          >
            Get a Quote
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden font-mono text-xs uppercase tracking-[0.2em] text-[#F4F3F0]"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#111110]/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              onClick={() => go(l.href)}
              className="text-left font-serif text-2xl text-[#F4F3F0]"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </motion.header>
  );
};
